import { containsOnlyWhiteSpaces } from './string';

export const validatePassword = (
  password: string,
  { required }: { required: boolean },
): string | undefined => {
  if (required && (!password || containsOnlyWhiteSpaces(password))) {
    return 'Por favor, introduce una contraseña';
  }

  if (password.length < 6) {
    return 'Por favor, utiliza una contraseña que contenga como mínimo 6 caracteres';
  } else {
    return;
  }
};
